// extracted by mini-css-extract-plugin
export var quantityInput = "_pl-0";